import { createFileRoute } from '@tanstack/react-router'
import { PlaygroundTeamsPane } from './-components/dev/transition-playground'

// The OUTER pager's second member — flat, no stack: swiping Jobs ↔ Teams exercises the section pager over a pane
// that contains a whole nav stack on one side and plain content on the other.
export const Route = createFileRoute('/_app/dev-resources/transitions/teams')({
  component: PlaygroundTeamsPane,
})
